/** @jsxImportSource @emotion/react */

import React from 'react';
import { View } from 'react-native-web';
import { connect } from 'react-redux';
import { IProduct, IProductWidget } from '@ddot/AddToCartCommon/lib/entities';

import PageSkeleton from 'Components/Skeletons/PageSkeleton';

import { RootState } from 'Redux/store';

import { useAppSelector } from 'Redux/hooks';
import NavActions from 'Services/Navigation/Actions';
import { ArrowRight, RightArrow1 } from 'Icons/Icons';
import ProductWidget from './Components/ProductWidget';
import Button from './Components/Button';
import Selectors from '../../Redux/Selectors';
import { section4, heroImage, heroTextContainer, btnCont1, section1, section2, section3 } from './Styles/HomeStyles';
import ButtonBlack from './Components/ButtonBlack';

interface HomeProps {
    productWidgetsLoading: boolean;
    productWidgets: IProductWidget[] | undefined;
    featuredProducts: IProduct[] | undefined;
    featuredProductsLoading: boolean;
}

const Home = (props: HomeProps) => {
    const { productWidgets, featuredProducts, featuredProductsLoading } = props;

    const goldPrice = useAppSelector(Selectors.getHomeGoldPrice);

    const navCategories = (category: string) => {
        NavActions.navToProductListingWithCategory(category);
    };

    const navToProducts = () => {
        NavActions.navToProductListing();
    };

    const navToAbout = () => {
        NavActions.navToAboutUs();
    };

    const renderWidgets = () => {
        const { productWidgetsLoading } = props;

        if (productWidgetsLoading) return <PageSkeleton />;

        if (!productWidgets || !productWidgets.length) return null;

        const bestSellers = productWidgets.find(item => item.title === 'New Arrivals');

        if (bestSellers) {
            return <ProductWidget key={bestSellers.title} widget={bestSellers} />;
        }

        return null;
    };

    return (
        <View>
            <div style={{ overflow: 'hidden' }}>
                <div style={{ position: 'relative', height: '100vh' }}>
                    <img src='bg1.png' alt='background' css={heroImage} />
                    <div css={heroTextContainer}>
                        <p className='heroText'>
                            Your Journey to
                            {' '}
                            <span style={{ fontFamily: 'Playfair', fontWeight: 400, fontStyle: 'italic' }}>Elegance</span>
                            <br />
                            Begins with TIANSI Jewellery
                        </p>
                        <p className='heroTextMobile'>
                            Your Journey to
                            {' '}
                            <span style={{ fontFamily: 'Playfair', fontWeight: 400, fontStyle: 'italic' }}>Elegance</span>
                            {' '}
                            Begins with TIANSI Jewellery
                        </p>
                        <div style={{ display: 'flex', gap: 20 }}>
                            <div
                                role='button'
                                tabIndex={0}
                                onClick={navToProducts}
                                onKeyPress={navToProducts}
                                css={[btnCont1, { backgroundColor: '#FFEC9F', border: '#B3761A' }]}
                            >
                                <p style={{ color: '#B3761A' }}>Shop Now</p>
                                <div className='heroArrow'>
                                    <ArrowRight />
                                </div>
                            </div>

                            <div
                                role='button'
                                tabIndex={0}
                                onClick={navToAbout}
                                onKeyPress={navToAbout}
                                css={[btnCont1, { backgroundColor: 'none', border: '1px solid #FFEC9F' }]}
                            >
                                <p style={{ color: '#FFEC9F' }}>About Us</p>
                                <div className='heroArrow'>
                                    <RightArrow1 />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div css={section1}>
                {renderWidgets()}
            </div>

            <div css={section2}>
                <div className='titleContainer'>
                    <h2 style={{ fontWeight: 'bold', fontSize: '4rem', letterSpacing: 2, transform: 'scale(1, 0.9)', margin: 0 }}>Our Best Sellers</h2>

                    <a href='/categories'><p style={{ color: '#064E72', textDecoration: 'underline', fontSize: '1.5rem', fontFamily: 'AcuminRPro', margin: 0 }}>View More</p></a>
                </div>
                <div className='container'>
                    <div className='leftContainer'>
                        <div className='imgCont'>
                            <img src='/assets/images/necklace.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>

                        <div className='textContainer'>
                            <p style={{ color: 'white', fontSize: '2rem', lineHeight: '28.8px' }}>Golden Petal Necklace</p>
                            <div
                                role='button'
                                tabIndex={0}
                                onClick={() => navCategories('N - NECKLACE')}
                                onKeyPress={() => navCategories('N - NECKLACE')}
                            >
                                <Button />
                            </div>
                        </div>
                    </div>
                    <div className='rightContainer'>
                        <div className='itemCont'>
                            <div className='imgCont'>
                                <img src='/assets/images/pendant.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>

                            <div style={{ position: 'absolute', bottom: 30, left: 30 }}>
                                <p style={{ color: 'white', fontSize: '2rem' }}>Double Love Pendant</p>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={() => navCategories('P - PENDANT')}
                                    onKeyPress={() => navCategories('P - PENDANT')}
                                >
                                    <Button />
                                </div>
                            </div>
                        </div>
                        <div className='itemCont'>
                            <div className='imgCont'>
                                <img src='/assets/images/bracelet.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>

                            <div className='textMobile'>
                                <p style={{ color: 'black', fontSize: '2rem' }}>Golden Bracelet</p>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={() => navCategories('T - BRACELET')}
                                    onKeyPress={() => navCategories('T - BRACELET')}
                                >
                                    <ButtonBlack />
                                </div>
                            </div>

                            <div className='textWeb'>
                                <p style={{ color: 'white', fontSize: '2rem' }}>Golden Bracelet</p>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={() => navCategories('T - BRACELET')}
                                    onKeyPress={() => navCategories('T - BRACELET')}
                                >
                                    <Button />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div css={section3}>
                <div>
                    <div style={{ width: '100%', height: 600 }}>
                        <img src='/bg1.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'none', objectPosition: '30% bottom', WebkitTransform: 'scaleX(-1)', transform: 'scaleX(-1)' }} />
                    </div>

                    <div className='textContainer'>
                        <div className='priceDate'>
                            <p>{new Date().toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' })}</p>
                        </div>
                        <div>
                            <h2 style={{ fontSize: '4rem', fontWeight: 'bold', paddingBottom: 15, letterSpacing: 2, transform: 'scale(1, 0.9)' }}>TIANSI Gold Price Quotes</h2>
                            {/* <p style={{ fontFamily: 'AcuminRPro', fontSize: '1.4rem', paddingBottom: 15 }}>Lorem ipsum dolor sit amet consectetur. Nisl velit ullamcorper dictum non. Justo senectus ultrices blandit malesuada. Cras bibendum purus feugiat volutpat nibh.</p> */}
                        </div>
                        <div className='priceText'>
                            <div>
                                <img src='/assets/icons/sparkle.png' alt='sparkle icon' />
                                <p style={{ fontFamily: 'AcuminRPro', fontSize: '1.4rem' }}>
                                    9999 - RM
                                    {goldPrice.gold9999}
                                    /G
                                </p>
                            </div>
                            <div>
                                <img src='/assets/icons/sparkle.png' alt='sparkle icon' />
                                <p style={{ fontFamily: 'AcuminRPro', fontSize: '1.4rem' }}>
                                    999 - RM
                                    {goldPrice.gold999}
                                    /G
                                </p>
                            </div>
                            <div>
                                <img src='/assets/icons/sparkle.png' alt='sparkle icon' />
                                <p style={{ fontFamily: 'AcuminRPro', fontSize: '1.4rem' }}>
                                    916(A)- RM
                                    {goldPrice.gold916A}
                                    /G
                                </p>
                            </div>
                            <div>
                                <img src='/assets/icons/sparkle.png' alt='sparkle icon' />
                                <p style={{ fontFamily: 'AcuminRPro', fontSize: '1.4rem' }}>
                                    916(B) - RM
                                    {goldPrice.gold916B}
                                    /G
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div css={section4}>
                <div>
                    <div>
                        <img src='/assets/icons/premium.png' alt='premium icon' />
                        <h1>Premium Quality</h1>
                        <p style={{ color: '#616161', fontFamily: 'AcuminRPro' }}>
                            Crafted from premium materials
                        </p>
                    </div>
                    <div>
                        <img src='/assets/icons/diverse.png' alt='premium icon' />
                        <h1>Diverse Selection</h1>
                        <p style={{ color: '#616161', fontFamily: 'AcuminRPro' }}>
                            Ranging from classic to contemporary styles
                        </p>
                    </div>
                    <div>
                        <img src='/assets/icons/luxury.png' alt='premium icon' />
                        <h1>Luxury Service</h1>
                        <p style={{ color: '#616161', fontFamily: 'AcuminRPro' }}>
                            We offer personalized shopping experience
                        </p>
                    </div>
                </div>
            </div>
        </View>
    );
};

const mapStateToProps = (state: RootState) => ({
    productWidgets: Selectors.getHomeProductWidgets(state),
    productWidgetsLoading: Selectors.getHomeProductWidgetsAttempting(state),
});

export default connect(mapStateToProps)(Home);
